import { differenceInYears, format, isValid, parseISO } from "date-fns";
import { LinkedAccount } from "../app/models/LinkedAccount";

export function parseBirthDate(value: LinkedAccount["birthDate"]): Date | null {
  if (value == null) return null;
  if (value instanceof Date) {
    return isValid(value) ? value : null;
  }
  if (typeof value === "number") {
    const d = new Date(value);
    return isValid(d) ? d : null;
  }
  if (typeof value === "string") {
    const d = parseISO(value);
    if (isValid(d)) return d;
    const n = Number(value);
    if (!Number.isNaN(n)) {
      const d2 = new Date(n);
      return isValid(d2) ? d2 : null;
    }
  }
  return null;
}

export function getLinkedAccountDisplayName(account: LinkedAccount): string {
  const nameAndSurname = account.nameAndSurname?.trim();
  if (nameAndSurname) return nameAndSurname;
  const fromData = account.holderData1?.trim();
  if (fromData) return fromData;
  return account.holderName?.trim() || "—";
}

/** Dzieli wyświetlaną nazwę na imię i nazwisko (pierwszy token → imię, reszta → nazwisko). */
export function splitDisplayNameToFirstLast(display: string): { firstName: string; lastName: string } {
  const trimmed = display.trim();
  if (!trimmed) return { firstName: "", lastName: "" };
  const parts = trimmed.split(/\s+/).filter(Boolean);
  if (parts.length === 1) return { firstName: parts[0], lastName: "" };
  return { firstName: parts[0]!, lastName: parts.slice(1).join(" ") };
}

export function getLinkedAccountInitials(account: LinkedAccount): string {
  const name = getLinkedAccountDisplayName(account);
  if (name === "—") return "?";
  const parts = name.split(/\s+/).filter(Boolean);
  if (parts.length >= 2) {
    return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
  }
  return name.slice(0, 2).toUpperCase();
}

export function formatBirthDateDdMmYyyy(account: LinkedAccount): string {
  const d = parseBirthDate(account.birthDate);
  if (!d) return "—";
  return format(d, "dd.MM.yyyy");
}

export function getLinkedAccountAge(account: LinkedAccount): number | null {
  const d = parseBirthDate(account.birthDate);
  if (!d) return null;
  return differenceInYears(new Date(), d);
}

export function formatSexLabel(sex: string | null | undefined, t: (key: string) => string): string {
  if (sex === "M" || sex === "m") return t("plec_mezczyzna");
  if (sex === "K" || sex === "k") return t("plec_kobieta");
  return "—";
}
